"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CachedFetchProvider = exports.CachedFetchContext = void 0;
const react_1 = __importStar(require("react"));
exports.CachedFetchContext = react_1.createContext({});
const defaultOptions = {
    fetcher: async (route, headers) => {
        const response = await fetch(route, { headers });
        const result = await response.json();
        if (!response.ok) {
            throw new Error(result.message || response.statusText || 'Request failed.');
        }
        return result;
    },
    headers: {},
    initialValue: undefined,
    dependencies: [],
};
exports.CachedFetchProvider = ({ globalOptions, persistence = 'none', persistencePrefix, children, }) => {
    const [cache, setCache] = react_1.useState(() => {
        if (persistence === 'none') {
            return {};
        }
        if (!persistencePrefix) {
            throw new Error('persistencePrefix must be provided when persistence is set to session or local');
        }
        const storage = persistence === 'session' ? sessionStorage : localStorage;
        const persistedCache = storage.getItem(`${persistencePrefix}-react-cached-fetch`);
        if (!persistedCache) {
            return {};
        }
        return JSON.parse(persistedCache);
    });
    const updateCache = react_1.useCallback((key, data) => {
        setCache((current) => (Object.assign(Object.assign({}, current), { [key]: data })));
    }, []);
    const memoizedGlobalOptions = react_1.useMemo(() => {
        if (!globalOptions) {
            return defaultOptions;
        }
        return Object.assign(Object.assign({}, defaultOptions), globalOptions);
    }, [globalOptions]);
    react_1.useEffect(() => {
        if (persistence === 'none' || !persistencePrefix) {
            return;
        }
        const storage = persistence === 'session' ? sessionStorage : localStorage;
        storage.setItem(`${persistencePrefix}-react-cached-fetch`, JSON.stringify(cache));
    }, [persistence, persistencePrefix, cache]);
    return (react_1.default.createElement(exports.CachedFetchContext.Provider, { value: {
            cache,
            updateCache,
            globalOptions: memoizedGlobalOptions,
        } }, children));
};
